// @ts-nocheck
import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';
import update from 'react-addons-update';
import * as constants from './constants';
import { TReducer } from './types';
export const initialState: TReducer = {
	data: {},
	isLoading: {},
	filters: {},
	metaData: {},
	selection: {},
	userSettings: {},
	events: {
		update: {},
		remove: {}
	}
};

const slice = createSlice({
	initialState,
	name: `${constants.MODEL_NAME}`,
	reducers: {
		updateComponentSettings(state, { payload }) {
			return {
				...state,
				userSettings: {
					...state.userSettings,
					[payload.ComponentName]: {
						metaData: _.omit({ ...payload, ...payload.ComponentMetaData }, ['ComponentMetaData'])
					}
				}
			};
		},
		cleanupGridData(state, { payload: { tableId } }) {
			return {
				...state,
				data: _.omit({ ...state.data }, tableId),
				isLoading: _.omit({ ...state.isLoading }, tableId),
				filters: _.omit({ ...state.filters }, tableId),
				metaData: _.omit({ ...state.metaData }, tableId),
				selection: _.omit({ ...state.selection }, tableId)
			};
		},
		updateGridData(state, { payload: { tableId, data, isAppend } }) {
			return {
				...state,
				data: {
					...state.data,
					[tableId]: isAppend
						? [...state.data[tableId], ..._.map(data, (d, i) => ({ ...d, index: i }))]
						: [..._.map(data, (d, i) => ({ ...d, index: i }))]
				}
			};
		},

		updateSelectedRows(state, { payload: { tableId, data } }) {
			return {
				...state,
				selection: {
					...state.selection,
					[tableId]: data
				}
			};
		},
		updateLoader(state, { payload: { eventName, isLoading } }) {
			return {
				...state,
				isLoading: {
					...state.isLoading,
					[eventName]: isLoading
				}
			};
		},
		updateFilters(state, { payload: { tableId, filters, pageNumber} }) {
			return {
				...state,
				filters: {
					...state.filters,
					[tableId]: {...filters, pageNumber}
				}
			};
		},
		updateMetadata(state, { payload: { tableId, metaData, isAppend, ...rest} }) {
			return {
				...state,
				metaData: {
					...state.metaData,
					[tableId]: isAppend ? { ...state.metaData[tableId], ...metaData, ...rest} : 
					{...metaData, ...rest}
				},
				...rest
			};
		},
		updateTableCell(state, { payload: { tableId, row, rowIdentifier, updatedValue } }) {
			try {
				return update(state, {
					data: {
						[tableId]: {
							[row.index]: {
								[rowIdentifier]: { $set: updatedValue }
							}
						}
					}
				});
			} catch (e) {}
		},
// 		updateMultiRows(state, { payload: { tableId, updatedRows, rowIdentifier, selectRowKey } }) {
// console.log(updatedRows,"updatedRows")
// 			return {
// 				...state,
// 				data: {
// 					...state.data,
// 					[tableId]: _.map(state.data[tableId], rp => {
// 						let row = _.find(updatedRows, gr => gr[selectRowKey] === rp[selectRowKey]);
// 						if (row) {
// 							return { ...rp, ...row };
// 						}
// 						return rp;
// 					})
// 				}
// 			};
// 		},

updateMultiRows(state, { payload: { tableId, updatedRows, rowIdentifier, selectRowKey } }) {
  const newTableData = state.data[tableId].map(rp => {
    const updated = updatedRows.find(gr => gr[selectRowKey] === rp[selectRowKey]);

    if (!updated) return rp;

    // merge base row
    const mergedRow = { ...rp, ...updated };

    // Enforce our updated structure (AG Grid safe) for ALL updated columns
    // Check all keys in the updated row to find columns with isUpdated flag
    Object.keys(updated).forEach(key => {
      if (key !== selectRowKey && updated[key] && typeof updated[key] === 'object' && updated[key].isUpdated) {
        mergedRow[key] = {
          value: updated[key]?.value ?? updated[key],
          isUpdated: updated[key]?.isUpdated ?? false,
        };
      } else if (key === rowIdentifier && updated[rowIdentifier] !== undefined) {
        // Also handle the specific rowIdentifier column
        mergedRow[rowIdentifier] = {
          value: updated[rowIdentifier]?.value ?? updated[rowIdentifier],
          isUpdated: updated[rowIdentifier]?.isUpdated ?? false,
        };
      }
    });

    return mergedRow;
  });

  return {
    ...state,
    data: {
      ...state.data,
      [tableId]: newTableData,
    },
  };
},


// updateMultiRows(state, { payload: { tableId, updatedRows, rowIdentifier, selectRowKey } }) {
//   const existingData = state.data[tableId] || [];
//   const newData = existingData.map(rp => {
//      const row = _.find(updatedRows, gr => gr[selectRowKey] === rp[selectRowKey]);
//     return row ? { ...rp, ...row } : rp;
//   });
//   return {
//     ...state,
//     data: {
//       ...state.data,
//       [tableId]: newData,
//     },
//   };
// },
		updateGridRowData(state, { payload: { tableId, row, rowIdentifier, newValue } }) {
			try {
				return update(state, {
					data: {
						[tableId]: {
							[row.index]: { $set: newValue }
						}
					}
				});
			} catch (e) {}
		},
		handleRowUpdateToggle(state, { payload }) {
			try {
				return update(state, {
					data: {
						[payload.tableId]: {
							[payload.row.index]: {
								isEditEnabled: { $set: payload.isEditEnabled }
							}
						}
					}
				});
			} catch (e) {}
		}
	}
});

export default slice;

export const {
	updateGridData,
	cleanupGridData,
	updateLoader,
	updateFilters,
	updateMultiRows,
	updateMetadata,
	updateTableCell,
	updateGridRowData,
	updateComponentSettings,
	updateSelectedRows,
	handleRowUpdateToggle
} = slice.actions;
